import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { Tabs } from 'antd';
import { Properties as Property } from './properties';
import PropertiesPanel from './PropertiesPanel';
import AssetPropertiesPanel from './AssetPropertiesPanel';
import DataPanel from './DataPanel';
import ValidationPanel from './ValidationPanel';
import { fCardSelect } from '../../../../../../helpers/RxServices';
import style from './props.module.sass'
import { ReactComponent as PropertyIcon } from '../../../../../../assets/svg/formIcons/Properties.svg'
import { ReactComponent as ValidationIcon } from '../../../../../../assets/svg/formIcons/Validation.svg'
import { ReactComponent as DataIcon } from '../../../../../../assets/svg/formIcons/Data.svg'
import { ReactComponent as LayoutIconSelected } from '../../../../../../assets/svg/layoutIcons/layout_sel.svg'
import { ReactComponent as LayoutIconUnSelected } from '../../../../../../assets/svg/layoutIcons/layout_unsel.svg'
import { Tooltip } from 'antd'
import { Layout } from './Layout'

// const { TabPane } = Tabs;

// const Properties = React.FC <Ivalidation>  () => {
interface Iproperties {
  selectedFormData: any[],
  canEdit: boolean
}

const Properties: React.FC<Iproperties> = (props) => {
  const [json, setJson] = useState<any>();
  const [bufferJson, setBufferJson] = useState<any>();
  const [tabNumber, setTabNumber] = useState<number>(0);
  const { canEdit, selectedFormData } = props;
  const { isMultipleSelection } = useSelector((state: any) => state.contextMenu)
  const assetEditMode = useSelector((state: any) => state.assets.assetEditMode)
  // const callback = (e: any) => {
  // }
  useEffect(() => {
    const subscription = fCardSelect.getMessage().subscribe((res) => {
      if (res.id) {
        // make the json null when a card is selected
        // this will cause the panels to remount, refreshing all input values with defaultValue prop
        setBufferJson({ ...res })
        setJson(null);
      }
    });
    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    // set buffer json to the original json if the json is null
    if (!json && bufferJson) {
      setJson({ ...bufferJson })
    }
  }, [json, bufferJson]);

  const renderPanels = (tabNumber: number, json: any) => {
    const { json: { type } } = json

    switch (tabNumber) {
      case 0:
        if (type === "Section" || type === "TabBar") {
          return <Property
            canEdit={canEdit}
            json={json}
            selectedFormData={selectedFormData}
          />
        } else {
          return <PropertiesPanel json={json} canEdit={canEdit} selectedFormData={selectedFormData} />
        }
      case 1:
        return <ValidationPanel json={json} canEdit={canEdit} />
      case 2:
        return <DataPanel json={json} canEdit={canEdit} />
      case 3:
        return <Layout canEdit={canEdit} json={json} />
      default:
        return null;
    }
  };

  const renderAssetPanel = (tabNumber: number, json: any) => {
    switch (tabNumber) {
      case 0:
        return (
          <AssetPropertiesPanel json={json} canEdit={canEdit} selectedFormData={selectedFormData} />
        )
      default:
        return null;
    }
  }

  return (
    // <Tabs defaultActiveKey="1" onChange={callback}>
    //   <TabPane className='override-properties-tab' tab={'Properties'} key="1">
    //     {json && <Property json={json} />}
    //   </TabPane>
    //   <TabPane tab="Validation" key="2">
    //     {json && json.json && json.json.type && !["Section",].includes(json.json.type) && <Validation json={json} defaultValue={validation}></Validation>}
    //   </TabPane>
    //   <TabPane className='override-data-tab' tab="Data" key="3">
    //     {json && json.json && json.json.type && ['Select', 'RadioButton', 'CheckBox', "CheckList", "Uploader", "Otp","DocumentCollector"].includes(json.json.type) && <Data json={json} defaultValue={codeAsync} />}
    //   </TabPane>
    // </Tabs>
    <div className={style.propertiesContainer}>
      <div data-test-id="properties" className={style.tabContainer}>
        <Tooltip title='Properties' placement='top' overlayClassName='propertiesPopUp'>
          <PropertyIcon data-test-id="property" style={{ height: '20px', width: '24px' }} onClick={() => setTabNumber(0)} className={tabNumber === 0 ? style.active : undefined} />
        </Tooltip>
        <Tooltip title='Validation' placement='top' overlayClassName='propertiesPopUp'>
          <ValidationIcon data-test-id="validation" style={{ height: '20px', width: '18px' }} onClick={() => setTabNumber(1)} className={tabNumber === 1 ? style.active : undefined} />
        </Tooltip>
        <Tooltip title='Data' placement='top' overlayClassName='propertiesPopUp'>
          <DataIcon data-test-id="data" style={{ height: '20px', width: '18px' }} onClick={() => setTabNumber(2)} className={tabNumber === 2 ? style.active : undefined} />
        </Tooltip>
        <Tooltip title='Layout' placement='top' overlayClassName='propertiesPopUp'>
          {
            tabNumber === 3 ?
              <LayoutIconSelected data-test-id="layout" style={{ height: '24px', width: '24px' }} />
              :
              <LayoutIconUnSelected data-test-id="layout_unselected" style={{ height: '24px', width: '24px' }} onClick={() => setTabNumber(3)} />
          }
        </Tooltip>
      </div>
      <div className={style.contentContainer}>
        {json && json.json && (!json.json.isAsset || assetEditMode) && !isMultipleSelection && renderPanels(tabNumber, json)}
        {json && json.json && json.json.isAsset && !assetEditMode && !isMultipleSelection && renderAssetPanel(tabNumber, json)}
      </div>
    </div>
  );
}


export default Properties;
